// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import '@/common/js/base'
import VueLazyLoad from 'vue-lazyload'
import api from "@/common/js/api"
import vueFilter from '@/common/js/filter'
import EncryptService from '@/common/js/encrypt'
import router from './router'
import $ from 'jquery'
//import './style/datatable.css'
//import './plugs/jQuery.print.js'

//过滤方法
for (let key in vueFilter) {
  Vue.filter(key, vueFilter[key])
}

//import Print from 'vue-print-nb'
//Vue.use(Print);
//使用插件打印 2019-9-23
import Print from '@/plugs/print'
Vue.use(Print)

Vue.use(ElementUI)
Vue.config.productionTip = false
/* eslint-disable no-new */

// 路由全局前置守卫
router.beforeEach((to, form, next) => {
  // title 设置
  document.title = to.meta.title;

  // 处理参数加密
  const encryptedParams = to.meta.encryptedParams || [];  // 获取路由配置的加密参数
  if (!to.query.fromEncrypt && encryptedParams.length > 0 && to.query && Object.keys(to.query).length > 0) {
    const finalUrl = EncryptService.encryptUrlParams(to.fullPath, encryptedParams);  // 加密特定参数
    if (finalUrl !== to.fullPath) {  // 如果有参数被加密，重定向到加密后的URL
      const encryptedPath = finalUrl.substring(finalUrl.indexOf('#') != -1 ? finalUrl.indexOf('#') + 1 : window.location.origin.length);
      next({
        path: `${encryptedPath}&fromEncrypt=true`,
      });
      return;
    }
  }

  next();
})


// 图片错误处理
Vue.use(VueLazyLoad, {
  error: './static/loading.png',
  loading: './static/loading.png'
})
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  data: {
    eventHub: new Vue(),
    api: api,
    isLoading: false,
    imgExt:'jpg,png,gif,jpeg,bmp',
    loadingTitle:"",//加载中标题设置
    flagrouter: false,
    routerPath: "",
    headershow: true,
    headershow1: true,
    headershow2: true,
    toplink: true,
    isLogin: true,//页面是否需要登录（获取用户信息）
    showLeftMenu: false,//显示左侧菜单
    showTopInfo: true,//显示顶部信息
    pagesn: '',//页面标记
  },
  mounted() {
    //setTimeout(function () {
    //  const _loaded = () => {
    //    //Print.focus();
    //    Print.print();
    //  };
    //  Print.onload = _loaded();
    //}, 200)

    // 监听所有带有 target="_blank" 的链接点击
    document.addEventListener('click', function (e) {
      if (e.target.tagName != 'A')
        return;

      const link = e.target.closest('a[target="_blank"]');
      if (link && link.href && link.href.includes(window.location.origin)) {
        // 解析URL
        const url = new URL(link.href);

        router.options.routes.forEach(route => {
          if (route.meta != null && route.meta.encryptedParams != null && route.meta.encryptedParams.length > 0 && 
            (route.path == url.pathname || ('/' + route.path + '/').replace(/\/+/g, '/').toLowerCase() == ('/' + url.pathname + '/').replace(/\/+/g, '/').toLowerCase())) {
            // 处理参数加密
            const finalUrl = EncryptService.encryptUrlParams(url, route.meta.encryptedParams);  // 加密特定参数
            if (finalUrl !== url) {  // 如果有参数被加密，重定向到加密后的URL
              link.href = finalUrl;
              return;
            }

            //方式2：throw "这里抛出异常后可正常触发beforeEach执行加密并且跳转到新标签页";
          }
        });
        // 事件继续传播，不阻止默认行为
      }
    });
  },
  methods: {
    getQueryStringByName(name) {
      var result = location.search.match(new RegExp("[\?\&]" + name + "=([^\&]+)", "i"));
      if (result == null || result.length < 1) {
        return "";
      }
      return result[1];
    },
    logShow(title, r, stringify = true) {
      console.log('%c' + title, 'background:#3333ff;color:#fff;');
      if (stringify) {
        console.log('%c' + JSON.stringify(r), 'color:#3333ff')
      }
      else {
        console.log(r)
      }
    }
  },
  watch: {
    $route(to, from) {
      this.routerPath = from.fullPath;
      if (to.name == '/Home') {
        this.flagrouter = true
      } else {
        this.flagrouter = false
      }
      //首页和子页面头部内容显示隐藏
      //if (to.name == '/ChooHotel') {
      //  this.headershow = false
      //  this.headershow1 = false
      //  this.headershow2 = false
      //}
      //else
      if (to.name == '/Login' || to.name == '/AuthCallback') { 
        this.logolink = false
        this.headershow = false
        this.headershow1 = true
        this.headershow2 = true
        this.showLeftMenu = false
        this.showTopInfo = false
      }
      else if (to.name == '/forgetpassword')
      {
        this.logolink = true
        this.headershow = false
        this.headershow1 = true
        this.headershow2 = true
        this.isLogin = false//是否获取用户信息=>是否需要登录
        this.showLeftMenu = false
        this.showTopInfo = false
      }
      else {
        this.logolink = true
        this.headershow = true
        this.headershow1 = true
        this.headershow2 = true
        this.showLeftMenu = true;
        this.showTopInfo = true
        }
      this.pagesn = this.getQueryStringByName('pagesn')
      console.log(this.pagesn);
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js